export interface DataModel {
	id: number;
	user_id: number;
	title: string;
	description: string;
	created_at: string;
	updated_at: string;
}

export interface RootObjectModel {
	current_page: number;
	data: DataModel[];
	first_page_url: string;
	from: number;
	last_page: number;
	last_page_url: string;
	next_page_url?: string | null;
	path: string;
	per_page: number;
	prev_page_url?: string | null;
	to: number;
	total: number;
}


export const initilizedDataModel =  {
	id: 0,
	user_id: 0,
	title: '',
	description: '',
	created_at: '',
	updated_at: '',
}

export const initilizedRootObjectModel = {
    current_page: 0,
	data: [initilizedDataModel],
	first_page_url: '',
	from: 0,
	last_page: 0,
	last_page_url: '',
	next_page_url: '',
	path: '',
	per_page: 50,
	prev_page_url: '',
	to: 0,
	total: 0
}